export default __webpack_public_path__ + "static/artifakt-legend-light-9b6e06a8c70ba6c206de10f9c8ddec8d.eot";